import { OrderModel } from "../../../screens/portfolio-info/types/OrderModel";
import { blackScholesModelCalculationService } from "../BlackScholesModelCalculationService";
import { AssetType } from "../../types/AssetType";
import { mathCalculationService } from "../MathCalculationService";
import { OrderState } from "../../types/OrderState";

export abstract class BaseCalculationService {
    calculateAtCurrent(orders: OrderModel[], underlyingPrice: number): number {
        let value = 0;

        orders.map(order => {
            if (this.isEnabled(order)) {
                const timeToExpirationInShareOfYear = order.expireAt !== null
                    ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(order.expireAt)
                    : null;
                
                value += this.calculate(order, underlyingPrice, timeToExpirationInShareOfYear);
            }
        });

        return value;
    }

    calculateAtCustom(orders: OrderModel[], underlyingPrice: number, customDate: Date): number {
        let value = 0;

        orders.map(order => {
            if (this.isEnabled(order)) {
                const timeToExpirationInShareOfYear = order.expireAt !== null
                    ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(order.expireAt, customDate)
                    : null;
                
                value += this.calculate(order, underlyingPrice, timeToExpirationInShareOfYear);
            }
        });

        return value;
    }

    calculateAtExpiration(orders: OrderModel[], underlyingPrice: number): number {
        let value = 0;

        orders.map(order => {
            if (this.isEnabled(order)) {
                value += this.calculate(order, underlyingPrice, this.getMinTimeToExpirationInShareOfYear());
            }
        });

        return value;
    }

    calculate(order: OrderModel,
              underlyingPrice: number, timeToExpirationInShareOfYear: number | null
    ): number {
        if (order.type === AssetType.Futures || order.type === AssetType.Spot) {
            return this.calculateForFutures(order);
        } else if (order.type === AssetType.Call || order.type === AssetType.Put) {
            if (timeToExpirationInShareOfYear === null) {
                throw new Error("Arg 'timeToExpirationInShareOfYear' is null.")
            }

            return this.calculateForOption(order, underlyingPrice, timeToExpirationInShareOfYear) * order.size;
        }

        throw new Error("Unknown AssetType");
    }
    
    protected abstract calculateForFutures(order: OrderModel): number;

    protected abstract calculateForOption(order: OrderModel,
        underlyingPrice: number, timeToExpirationInShareOfYear: number
    ): number;

    protected getMinTimeToExpirationInShareOfYear(): number {
        return 0;
    }

    protected round(value: number, precision: number): number {
        return mathCalculationService.round(value, precision);
    }

    private isEnabled(order: OrderModel): boolean {
        return order.state !== OrderState.Disabled;
    }
}
